export default {
  title: "CBAM Schnellsuche",
  subtitle: {
    noReg: "Keine Registrierung erforderlich",
    free: "Kostenlos",
    minutes: "1 Minute",
  },
  steps: {
    country: "Land",
    product: "Produkt",
    volume: "Importvolumen",
    result: "Ergebnis",
  },
  step1: {
    title:
      "Importieren Sie aus einem Land außerhalb der EU in die EU oder handeln innerhalb der EU?",
    outsideEU: "Import von außerhalb der EU",
    insideEU: "Innerhalb der EU (befreit)",
  },
  step2: {
    title: "Hauptimportwaren? (Mehrfachauswahl möglich)",
    steel: "Stahl",
    aluminum: "Aluminium",
    cement: "Zement",
    fertilizer: "Düngemittel",
    electricity: "Strom",
    hydrogen: "Wasserstoff",
    other: "Andere",
  },
  step3: {
    title: "Geschätztes EU-Importvolumen in 2026?",
    lt50t: "< 50 Tonnen (befreit)",
    between50_500t: "50–500 Tonnen",
    gt500t: "> 500 Tonnen",
  },
  result: {
    lowRisk: "Geringes Risiko",
    mediumRisk: "Mittleres Risiko",
    highRisk: "Hohes Risiko",
    insideEU:
      "Glückwunsch! Der EU-interne Handel ist befreit, es ist keine Meldung/Zahlung erforderlich. Aber wir empfehlen, Veränderungen zu überwachen.",
    outsideEU:
      "Glückwunsch! Jahresvolumen < 50 Tonnen Befreiung oder nicht abgedeckte Waren, keine Meldung/Zahlung erforderlich. Aber wir empfehlen, Veränderungen zu überwachen.",
    highRiskDesc:
      "Muss melden + Zertifikate kaufen (basierend auf Emissionen), Fehler > 10% führt zu einer Strafe von €1K–€10K.",
    mediumRiskDesc:
      "Quartalsberichterstattung erforderlich, ab 2026 möglicherweise Zahlungspflicht. Wir empfehlen, PwC-Formatberichte zu erstellen, um Risiken zu minimieren.",
  },
  whyChoose: {
    title: "Warum TaxEcoBit wählen?",
    description:
      "TaxEcoBit hilft Ihnen bei der Berechnung mit 90%+ Genauigkeit, konforme PDF/Excel in 3 Sekunden.",
    features: {
      accurate: "Genauigkeit und Einhaltung: Fehler <10%, entspricht CBAM-Anforderungen",
      fast: "Schneller Bericht: 3 Sekunden für die Erstellung konformer PDF/Excel",
      cost: "Kostenvorteil: €99/Monat, weit unterhalb der Wettbewerber €500+/Monat",
      trial: "14 Tage kostenlose Testversion, alle Premium-Funktionen ausprobieren",
    },
  },
  newRule:
    "Neue Regelung 2026: Jahresvolumen < 50 Tonnen befreit (außer Wasserstoff/Strom), aber Berichte müssen präzise sein, um Strafen zu vermeiden.",
  buttons: {
    prev: "Zurück",
    next: "Weiter",
    viewResult: "Ergebnis ansehen",
    generateReport: "Vollständigen Bericht erstellen (Kostenlose Anmeldung/Probeversion)",
    restart: "Neu starten",
  },
};
